import { render } from "./Authorization.vue?vue&type=template&id=0c684dd7"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/index/components/Authorization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c684dd7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c684dd7', __exports__)) {
    console.log('reload')
    api.reload('0c684dd7', __exports__)
  }
  
  module.hot.accept("./Authorization.vue?vue&type=template&id=0c684dd7", () => {
    console.log('re-render')
    api.rerender('0c684dd7', render)
  })

}


export default __exports__